module.exports = __webpack_public_path__ + "media/images/front/brands/creations/creations_header_2_m-9f64f1fc3fd31cbf0f13f9923110520f.jpg";